<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row g-3">
    <div class="col-12">
      <label for="comment" class="form-label">
        Comentario
        @if (required) {
        <span>*</span>
        }
      </label>
      <textarea
        id="comment"
        class="form-control"
        rows="3"
        [placeholder]="placeholder"
        [formControl]="commentControl"
        [ngClass]="{
          'is-invalid': commentControl.invalid && commentControl.touched
        }"
      ></textarea>
      @if (commentControl.invalid && commentControl.touched) {
      <div class="invalid-feedback">
        El comentario es requerido.
      </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary btn-spacing"
    (click)="activeModal.dismiss('Cancel click')"
  >
    Cancelar
  </button>
  <button
    type="button"
    class="btn btn-success btn-spacing"
    [disabled]="commentControl.invalid"
    (click)="confirm()"
  >
    Confirmar
  </button>
</div>
